module.exports = __webpack_public_path__ + "media/images/pic/ramen1-6f5b026c5794d861532144640b72638f.svg";